// ThemeToggle — cycles through 'auto' | 'light' | 'dark' theme modes.
// Applies via changeGlobalTheme (never direct data-theme mutation).
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
// Per DESIGN domain knowledge: never mutate data-theme from project code;
// use changeGlobalTheme(name) from scratch.
//
// Mode arithmetic + persistence live in the shared `cycleTheme` helper
// (shared/functions/cycleTheme.js); the verbose ThemeItem row in
// AppHeader shares the same helper so both surfaces stay in sync.

// An icon-only control, so it is the kit's square (CompactIconButton — the
// icon-button law, DESIGN-WL-ICON-BUTTONS-SQUARE-1). It was the capsule Button
// atom with a `Z1` padding: a 44 px min-height around a narrower glyph box,
// never 1 / 1. The quiet `tertiary` theme and the round plate come from
// IconButton / CompactIconButton.
export const ThemeToggle = {
  extends: 'CompactIconButton',
  title: (el, s) => el.call('labelForTheme', s.root?.themeMode),

  Icon: {
    name: (el, s) => el.call('iconForTheme', s.root?.themeMode)
  },

  onClick: (e, el, s) => {
    e.preventDefault()
    const next = el.call('cycleTheme', s.root)
    // Apply through the framework-approved path so scratch owns data-theme
    // and design-system reprocessing. cycleTheme already wrote root state +
    // localStorage; this surface just needs to flip the runtime theme.
    el.call('changeGlobalTheme', next)
    // An EXPLICIT choice also lands on the user record (user_preferences.
    // themeMode) so it follows the user across devices and wins over `auto`
    // thereafter (Nika 2026-08-16). Fire-and-forget: the local cache above
    // already applied it; the record is the durable copy.
    el.call('persistThemeModeToUser', s.root, el.sdk, next)
  }
}
